import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useEffect } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants/srp';
import { useIsLoggedIn } from '~/context/common/UserContext';
import SearchContext from '~/context/srp/SearchContext';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';

export default function useShowFinance(): void {
  const { setShowFinance } = useContext(SearchContext);
  const isLoggedIn = useIsLoggedIn();

  const { request } = useGenerateInventoryRequest(MAX_PAGE_SIZE_DEFAULT);

  // Authenticated users should always see financing.
  useEffect(() => {
    if (isLoggedIn) setShowFinance(true);
  }, [isLoggedIn, setShowFinance]);

  // After the user interacts with the page, advertising financing to them is fair game.
  useSubsequentEffect(() => {
    setShowFinance(true);
  }, [request, setShowFinance]);
}
